import React, { useEffect, useState } from "react";
import { BsCalendar2Date } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { userProfile } from "../admin-data/data";
import { MdOutlineLogout,MdMenu,MdOutlineClose } from "react-icons/md";
import { useSelector, useDispatch } from "react-redux";
import { closeSidebar, openSidebar, toggleSidebar } from "../../redux/store/sidebarSlice";

const Topbar = () => {
  const [todayDate, setTodayDate] = useState("");
  const [isActive, setIsActive] = useState(false);
  const navigate = useNavigate();
 const isOpen = useSelector((state) => state.sidebar.isOpen);
  const dispatch = useDispatch();
  useEffect(() => {
    
    const today = new Date();
    const day = today.getDate(); // 1-31
    const month = today.toLocaleString("default", { month: "short" }); // Jan, Feb, Mar
    setTodayDate(`${day} ${month}`);
  }, []);
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 900) {
        dispatch(closeSidebar()); // force hide if width < 900
      } else {
        dispatch(openSidebar()); // show sidebar on larger screens
      }
    };

    // Call once on mount
    handleResize();

    // Listen to resize
    window.addEventListener("resize", handleResize);

    // Cleanup
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [dispatch]);
  return (
    <div className="px-[3rem] py-[1.5rem]  text-white flex justify-between items-center">
      <div className="relative flex justify-center gap-[1rem] items-center">
        <button onClick={() => dispatch(toggleSidebar())}><MdMenu size={'30'}/> </button>
      <h1 className="font-bold text-[1.8rem]">Overview</h1>
      </div>
      <div className="relative flex justify-center gap-[1rem] items-center">
        <div
          onClick={() => {
            navigate("/");
          }}
          className="text-gray-300 font-semibold text-md px-[1rem] rounded-md hover:bg-gray-800 py-[0.6rem] bg-gray-700 cursor-pointer transition-all duration-200"
        >
          View Website
        </div>
        <div className="text-gray-300 flex justify-center gap-[0.5rem] items-center font-semibold text-md px-[1rem] rounded-md py-[0.6rem] bg-gray-700">
          <BsCalendar2Date size={"18px"} />
          {todayDate}
        </div>

        <div
          onClick={() => {
            setIsActive(!isActive);
          }}
          className="bg-gray-700 w-[42px] h-[42px] rounded-full cursor-pointer"
        >
          <img
            src="https://img.icons8.com/clouds/1200/user-male-circle.jpg"
            alt=""
            className="rounded-full"
          />
        </div>
        {isActive && (
          <div
            className="text-white absolute top-16 right-4 
                w-80 md:w-80 bg-gray-700 rounded-md
                px-4 py-6 shadow-lg"
          >
            <div className="flex items-center gap-4">
              <img
                src="https://img.icons8.com/clouds/1200/user-male-circle.jpg"
                alt=""
                className="w-[50px] h-[50px] rounded-full"
              />
              <div>
                <p className="font-bold  text-[18px]">Amaar Admin</p>
                <p className="font-light mt-[-5px] text-[16px]">
                  amaaradmin@gmail.com
                </p>
              </div>
            </div>
            <hr className="mt-[1.5rem]" />
           <div className="flex flex-col items-start gap-2 mt-6 w-full rounded-md">
  {userProfile.map((item, index) => (
    <div
      key={index}
      className="flex items-center gap-2 text-white px-4 py-2 w-full rounded-md hover:bg-gray-800 cursor-pointer transition-all duration-200"
    >
      {item.icon}
      {item.title}
    </div>
  ))}
  <div
      className="flex items-center gap-2 text-white px-4 py-2 w-full rounded-md hover:bg-gray-800 cursor-pointer transition-all duration-200"
    >
      <MdOutlineLogout size={'1.2rem'}/>
      Logout
    </div>
</div>

          </div>
        )}
      </div>
    </div>
  );
};

export default Topbar;
